var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMove = function SvgMove(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2.893 8.818 6.075l1.06 1.061 1.372-1.371v5.485H5.765l1.371-1.371-1.06-1.061L2.894 12l3.182 3.182 1.06-1.06-1.371-1.372h5.485v5.485L9.88 16.864l-1.06 1.06L12 21.107l3.182-3.183-1.06-1.06-1.372 1.371V12.75h5.485l-1.371 1.371 1.06 1.06L21.108 12l-3.182-3.182-1.061 1.06 1.371 1.372H12.75V5.765l1.371 1.371 1.061-1.06L12 2.892Z",
    fill: "#080341"
  })));
};
export default SvgMove;